import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'core-js';
import { I18nextProvider } from 'react-i18next';
import { pdfjs } from 'react-pdf';
import { BrowserRouter } from 'react-router-dom';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import workerLegacyUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';
import { useEffect } from 'react';
import { AppRoutes } from './AppRoutes';
import useAppropriateFavicon from './hooks/useAppropriateFavicon';
import i18n from './services/i18next/i18nextConfig';
import { queryClient } from './services/react-query/queryClient';
import { SetUserLanguage } from './utils/SetUserLanguage';
import { IdentifyPosthog } from './services/posthog/IdentifyPosthog';
import { UserDataProvider } from './services/firebase/state/UserDataProvider';
import { CheckForceReload } from './utils/CheckForceReload';
import { useFeatureFlags } from './services/posthog/featureFlags';

function App() {
  const { legacyBrowserFlag } = useFeatureFlags();

  useEffect(() => {
    console.log(`Legacy browser mode: ${legacyBrowserFlag}`);
    pdfjs.GlobalWorkerOptions.workerSrc = legacyBrowserFlag ? workerLegacyUrl : workerUrl;
  }, [legacyBrowserFlag]);

  useAppropriateFavicon();
  return (
    <UserDataProvider>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <SetUserLanguage />
            <IdentifyPosthog />
            <CheckForceReload />
            <AppRoutes />
          </BrowserRouter>
        </I18nextProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </UserDataProvider>
  );
}

export default App;
